"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const constants_1 = require("./constants");
const theme_1 = __importDefault(require("./global/theme"));
const AppContextProvider_1 = __importDefault(require("./contexts/AppContextProvider"));
const react_router_dom_1 = require("react-router-dom");
const login_1 = __importDefault(require("./pages/login"));
const test_1 = __importDefault(require("./pages/test"));
const helpers_1 = require("./helpers");
const useGetEssentialDataAndTranslations_1 = __importDefault(require("./hooks/useGetEssentialDataAndTranslations"));
const useOtpLink_1 = require("./hooks/useOtpLink");
const SsoFlow = react_1.default.lazy(() => Promise.resolve().then(() => __importStar(require("./ComponentScreens"))));
const App = () => {
    const [isSsoModalOpen, setIsSsoModalOpen] = (0, react_1.useState)(false);
    const [otpData, setOtpData] = (0, react_1.useState)();
    const themeReducer = (state, action) => {
        switch (action.type) {
            case "SET_THEME":
                return Object.assign(Object.assign({}, state), action.data);
            default:
                return state;
        }
    };
    const [theme, dispatch] = (0, react_1.useReducer)(themeReducer, theme_1.default);
    theme.direction = theme.locale === "ar" ? "rtl" : "ltr";
    theme.isLTR = theme.locale === "en";
    theme.isRTL = theme.locale === "ar";
    theme.locale = theme.locale === "en" ? "en" : "ar";
    theme.isMobile = theme.device === "mobile";
    theme.isDesktop = theme.device === "desktop";
    const { countries, cities, ssoConf, translations } = (0, useGetEssentialDataAndTranslations_1.default)(theme);
    theme.city = cities === null || cities === void 0 ? void 0 : cities.find((city) => city.id === Number(theme.cityId));
    theme.translations = translations;
    (0, react_1.useEffect)(() => {
        document.addEventListener(constants_1.CLOSE_SSO_MODAL_EVENT, () => {
            setIsSsoModalOpen(false);
        });
    }, []);
    (0, react_1.useEffect)(() => {
        document.addEventListener(constants_1.OPEN_SSO_MODAL_EVENT, (event) => __awaiter(void 0, void 0, void 0, function* () {
            dispatch({
                type: "SET_THEME",
                data: {
                    locale: event.detail.language,
                    country: event.detail.country,
                    device: event.detail.platform,
                    cityId: event.detail.cityId,
                    redirectUrl: event.detail.redirectUrl,
                    completionUrl: event.detail.completionUrl
                },
            });
            setOtpData({
                otp: event.detail.otp || "",
                phoneNumber: event.detail.phoneNumber || "",
                email: event.detail.email || "",
                linkType: event.detail.linkType,
            });
            setIsSsoModalOpen(true);
        }));
    }, []);
    //this  hook used to handle otp link
    (0, useOtpLink_1.useOtpLink)();
    (0, react_1.useEffect)(() => {
        if (window.location.href.includes("/login?redirectUrl=")) {
            const country = (0, helpers_1.getQueryStringValue)("country");
            const platform = (0, helpers_1.getQueryStringValue)("platform");
            const language = (0, helpers_1.getQueryStringValue)("language");
            const cityId = (0, helpers_1.getQueryStringValue)("cityId");
            dispatch({
                type: "SET_THEME",
                data: {
                    locale: language,
                    country: country,
                    device: platform,
                    fullPage: true,
                    cityId: Number(cityId),
                },
            });
        }
    }, []);
    if (countries.length === 0 || !translations) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    return ((0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { children: (0, jsx_runtime_1.jsxs)(styled_components_1.ThemeProvider, Object.assign({ theme: Object.assign({}, theme) }, { children: [theme.fullPage && ((0, jsx_runtime_1.jsxs)("head", { children: [(0, jsx_runtime_1.jsx)("meta", { name: "viewport", content: "width=device-width, height=device-height ,initial-scale=1.0, shrink-to-fit=no" }, "viewport"), (0, jsx_runtime_1.jsx)("meta", { name: "robots", content: "noindex, nofollow" }), (0, jsx_runtime_1.jsx)("meta", { httpEquiv: "Content-Type", content: "text/html; charset=utf-8" }), (0, jsx_runtime_1.jsx)("title", { children: translations.openSooqSso.title })] })), isSsoModalOpen && ((0, jsx_runtime_1.jsx)(AppContextProvider_1.default, Object.assign({ countries: countries, ssoConfigurations: ssoConf, otpData: otpData }, { children: (0, jsx_runtime_1.jsx)(react_1.Suspense, Object.assign({ fallback: (0, jsx_runtime_1.jsx)("div", {}) }, { children: (0, jsx_runtime_1.jsx)(SsoFlow, { setIsSsoModalOpen: setIsSsoModalOpen }) })) }))), (0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/login", element: (0, jsx_runtime_1.jsx)(login_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/test", element: (0, jsx_runtime_1.jsx)(test_1.default, {}) })] })] })) }));
};
exports.default = App;
